import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
export const StyledGrid = styled(Grid)(({ theme }) => ({
    marginBottom: theme.spacing(8.75),
    [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(4),
    },
}));
export const StyledGridItem = styled(Grid, {
    shouldForwardProp: (prop) => prop !== 'justify',
})(({ theme, justify }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: justify,
    [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
    },
}));
//# sourceMappingURL=styles.js.map